import { render, staticRenderFns } from "./OtherEdit.vue?vue&type=template&id=93f88904"
import script from "./OtherEdit.vue?vue&type=script&lang=js"
export * from "./OtherEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports